import type { FaireProductEntity } from "../../entity_types/product";

export const p_mmcbhxghnx: FaireProductEntity = {
  token: "p_mmcbhxghnx",
  type: "product",
  name: "Baseball Baby Gown and Hat",
  brandToken: "b_dlso2ccw88",
  brandName: "Adorable Sweetness",
  imageUrl:
    "https://cdn.faire.com/fastly/f93eb0ee43064f284f2b37b427061388a81c4b2acc296ad790682518e8676b8d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3d8beff0cae97c55128207d6ec193a80c5bb104c375147c7d02e1208d57d39a0.jpeg",
    "https://cdn.faire.com/fastly/5abde9261dd94afce78022f739160c3814b15af9735c3bc3e9b8e0f12b87e99f.jpeg",
    "https://cdn.faire.com/fastly/42ea8b1e3090bd1ed1babab9b4a137b5cc3b63a7afbf093bd566f0af49425de9.jpeg",
  ],
  priceDollars: 9.99,
  description:
    "Size is 0-3 Months\nIncludes a free matching hat!\n\nEnjoy this adorable baseball print sleep gown for your precious new arrival. Our gowns are made of a quality 95% polyester and 5% spandex blend that leaves your babe feeling super soft & incredibly cozy. The sturdy elastic at the bottom allows parents quick access for diaper changes and will keep little toes tucked in during all hours of the day and night.\n",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:26:11.533Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
